// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4283 ? "fe680085" : chunkId) + "." + {"4283":"a841e1788f815e17","5448":"60fc36adc33dd5e4"}[chunkId] + ".js";
};